import React, { FC } from 'react'

import { DemoPopup } from 'pages/soundscape-page/components/DemoPopup'

import bg from './assets/feel-bg.jpg'
import mobileBg from './assets/feel-bg-mobile.jpg'

import type { SoundscapeDemoPopupContent } from 'redux/popupReducer'

interface SoundscapeFeelProps {
  content: SoundscapeDemoPopupContent
}

export const SoundscapeFeel: FC<SoundscapeFeelProps> = ({ content }) => {
  return (
    <DemoPopup
      backgroundImage={bg}
      mobileBackgroundImage={mobileBg}
      logo={content.logoUrl}
      title={content.title}
      description={content.description}
    />
  )
}
